module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/facebook-ac1adeaf145c4bb9c474a96139141fe4.svg";